// Polyfill for older browsers
import 'babel-polyfill'
import 'es6-promise/auto'

// NOTE: It is important to use import and never require() because anything in a require() will
// make that module not able to be overridden

// Import CSS Files


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/main.css'
import 'font-awesome-webpack'
import './assets/xm-style.css'
import './assets/toggles.css'
import './assets/tooltips.css'
import './assets/darkmode.css'


import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import store from './store/index'
import router from './router/index'

import App from './App'

sync(store, router)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js